<template lang="pug">
section.configuration(v-if="loaded")
  .content
    .main
      .validation-error(v-if="products.ModelValidation && !products.ModelValidation.IsValid")
        | {{ products.ModelValidation.Message }}
      h1.configuration-title {{ products.name }}
      ProductSheet(:title="products.name", :configID="configID", :products="products")
      .section.bill-of-materials
        h2.section-title Bill of Materials
        .products
          ProductTile(:product="products.connectors[0]", :showPDF="true", :createLink="false")
          ProductTile(:product="products.cable", :showPDF="true", :createLink="false")
          ProductTile(:product="products.connectors[1]", :showPDF="true", :createLink="false")
      .section(v-if="related.length")
        h2.section-title Mating Connectors
        .products
          ProductTile(
            v-for="product in related",
            :key="product.sku",
            :product="product", 
            :showPDF="false",
            :createLink="true")
    .rail
      Cart(
        :title="products.name",
        :configID="configID",
        :price="products.price",
        :emailTopic="products.configuration.emailTopic",
        :emailBody="products.configuration.emailBody",
        :isValid="!products.ModelValidation || products.ModelValidation.IsValid")
</template>

<script>
// @ is an alias to /src
import ProductSheet from "@/components/configuration/ProductSheet.vue";
import Cart from "@/components/configuration/Cart.vue";
import ProductTile from "@/components/configuration/ProductTile.vue";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Configuration",
  components: {
    ProductSheet,
    Cart,
    ProductTile,
  },
  data() {
      return {
      loaded: false,
      configID: null,
      products: null
    };
  },
  computed: {
    ...mapGetters(["configLookup", "relatedLength"]),
      related() {
      const connectors = [this.products.connectors[0], this.products.connectors[1]];
      const related = connectors.reduce((related, product) => {
        const { matingConnectors} = product;
          if (matingConnectors) {
          matingConnectors.forEach((matingConnector) => {
            if(!related.includes(matingConnector)){
              related.push(matingConnector);
            }
          });
        }
        return related;
      }, []);

          return related;
    },
  },

   methods: {
    ...mapMutations(["setConfiguration", "setErrorMessage"]),
  },
  async created() {
      const configID = this.$route.params.product;
      const length = this.$route.query.length;
      const delay = this.$route.query.delay;
      console.log(this.$route.query);      
    if (!configID) return this.$router.replace({ path: "/" });

      const response = await fetch(`${this.$root.detailsApi}/${configID}?length=${length}&delay=${delay}`);      
      //const response = await fetch(`${this.$root.detailsApi}`);
      if (response.ok) {
          const productDetails = await response.json();
          if (productDetails["errorMessage"]) {
              this.setErrorMessage(productDetails["errorMessage"]);
              return this.$router.replace({ path: "/" });
          }
          this.products = productDetails;
          this.configID = productDetails['configID'];
          const value = productDetails['configuration'];
          
          this.setConfiguration(value);
          this.loaded = true;

      }
      else {
          return this.$router.replace({ path: "/" });
      }
  },
};
</script>


<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @include mq(lg) {
    flex-direction: row;
    align-items: flex-start;
  }
}

.main,
.rail {
  display: flex;
  flex-direction: column;
  background: $white;
  box-shadow: 0 0 0.5rem rgba($black, 0.0375), 0 0 1rem rgba($black, 0.02);
  @media print {
    background: transparent;
    box-shadow: none;
  }
}

.main {
  padding: clamp(1.125rem, 3vw, 2rem);

  @include mq(lg) {
    flex: 1 1 100%;
  }
}
.rail {
  order: -1;
  @include mq(lg) {
    order: 1;
    position: sticky;
    top: 1.5rem;
    flex: 0 0 22rem;
  }
}

.validation-error {
  background: #fff3f3;
  border: 1px solid #e53e3e;
  border-radius: 0.25rem;
  color: #c53030;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  font-size: 0.9375rem;
}

.configuration-title {
  font-weight: 400;
  font-size: 1.125rem;
  margin: 0 0 1.5rem;
}

.section {
  margin-top: 2.5rem;
}

.section-title {
  font-weight: 400;
    font-size: 1.5rem;
  margin: 0 0 1.5rem;

}

.products {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-auto-rows: 1fr;
  gap: 1rem;
}
</style>